// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6C16x","textarea":"styles_textarea__2irbF"};